import React, { useEffect, useState } from "react";
import "./About.css";

function About() {
  const [aboutData, setAboutData] = useState(null);

  // Fetch About Chapter data from backend
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await fetch("https://blog.dietchapter.hosting.acm.org/about-chapter");
        const data = await res.json();
        setAboutData(data);
      } catch (err) {
        console.error("❌ Failed to fetch About Chapter:", err);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <section id="about" className="about-chapter-section">
      {aboutData && (
        <div className="about-content">
          <div className="about-left">
            <img
              src={`https://blog.dietchapter.hosting.acm.org/${aboutData.imagePath}`}
              alt="About Chapter"
              className="about-image"
            />
          </div>

          <div className="about-right">
            <h2>About Our Chapter</h2>
            <p className="about-description">{aboutData.description}</p>

            <div className="about-stats">
              <div className="stat-box">
                <h3>{aboutData.activeMembers || 0}+</h3>
                <p>Active Members</p>
              </div>
              <div className="stat-box">
                <h3>{aboutData.eventsOrganized || 0}+</h3>
                <p>Events Conducted</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default About;
